import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=f48db3ca&scoped=true&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"
import style0 from "./Article.vue?vue&type=style&index=0&id=f48db3ca&prod&lang=css&"
import style1 from "./Article.vue?vue&type=style&index=1&id=f48db3ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48db3ca",
  null
  
)

export default component.exports